<form class="wrapper" #formRef="ngForm">
	<ng-container *ngIf="entity">
		<h2 *ngIf="entity?.id !== 'new'">{{ 'EDIT_' + label | translate }} </h2>
		<h2 *ngIf="entity?.id === 'new'">{{ 'CREATE_' + label | translate }} </h2>
		<p *ngIf="entity?.id !== 'new'">{{ 'HELP.BB_LIVESTREAM_EDIT_RESTREAM' | translate }}</p>
		<div class="status">
			<bb-status *ngIf="entity" [(ngModel)]="entity.state" name="status" [labelOn]="'ENABLED' | translate" [labelOff]="'DISABLED' | translate" [valueOff]="'disabled'" [valueOn]="'enabled'" ></bb-status>
		</div>
		<bb-form-element [form]="form" [label]="'RESTREAM_TITLE' | translate">
			<bb-text [ngClass]="{disabled: entity?.id !== 'new'}" [(ngModel)]="entity.title" name="title"></bb-text>
		</bb-form-element>
		<bb-form-element [form]="form" [label]="'RESTREAM_TYPE' | translate">
			<bb-select [ngClass]="{disabled: entity?.id !== 'new'}" [(ngModel)]="entity['restream-type']" [options]="restreamTypeOptions" name="restream-type"></bb-select>
		</bb-form-element>
		<bb-form-element [form]="form" [label]="'RESTREAM_URL' | translate" [helpMessage]="'HELP.RESTREAM_URL' | translate">
			<bb-text [ngClass]="{disabled: entity?.id !== 'new'}" [(ngModel)]="entity['restream-url']" name="restream-url">
			</bb-text>
		</bb-form-element>
		<bb-form-element [form]="form" [label]="'RESTREAM_NAME' | translate" [helpMessage]="'HELP.RESTREAM_NAME' | translate">
			<bb-text [ngClass]="{disabled: entity?.id !== 'new'}" [(ngModel)]="entity['restream-name']" name="restream-name">
			</bb-text>
		</bb-form-element>
		<bb-form-element [form]="form" [label]="'TARGET_URL' | translate" [helpMessage]="'HELP.RESTREAM_TARGET_URL' | translate">
			<bb-text [ngClass]="{disabled: entity?.id !== 'new'}" [(ngModel)]="entity['public-url']" name="public-url"></bb-text>
		</bb-form-element>
	</ng-container>
</form>
<div class="actions" *ngIf="entity && form">
	<button class="button" (click)="delete()" [hidden]="entity.id === 'new'"><i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</button>
	<button class="button submit" (click)="save()"><i class="fa fa-floppy-o"></i> {{ 'SAVE' || translate }}</button>
	<button class="button cancel" (click)="onCancelClick()"><i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}</button>
</div>
